import type { Member, User } from '@vincerosoft/assessfluence-types';
import { SurveyResponse } from '@vincerosoft/assessfluence-types';

export const assembleRespondents: (
  members: Pick<Member, 'id' | 'user_id' | 'status'>[],
  users: Pick<User, 'id' | 'email' | 'name' | 'uid'>[]
) => SurveyResponse['respondent'][] = (
  members: Pick<Member, 'id' | 'user_id' | 'status'>[],
  users: Pick<User, 'id' | 'email' | 'name' | 'uid'>[]
) =>
  members.reduce<SurveyResponse['respondent'][]>((acc, { id: member_id, user_id, status }) => {
    if (status !== 'active') {
      return acc;
    }

    const user = users.find((u) => u.id === user_id);
    if (!user) {
      return acc;
    }
    const { id: _id, ...rest } = user || {
      id: '',
      email: '',
      name: '',
      uid: ''
    };
    acc.push({
      member_id,
      user_id,
      ...rest
    });
    return acc;
  }, []);
